import { NewOAuthEmailIntegration } from './NewOAuthEmailIntegration';

export const NewGoogleEmailIntegration = ({ onClose }) => {
  return (
    <NewOAuthEmailIntegration
      onClose={onClose}
      provider="Google"
      apiEndpoint="gmail/auth-url"
    />
  );
};
